export class Staff {
    name: string;
    id: number;

    staff_id: number;
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    reset_token: string;
    role_title: string;
    role_slug: string;

    types = [];
    stats = [];

    constructor() { }

    formattedName() {
        return this.first_name + " " + this.last_name;
    }

}


// WEBPACK FOOTER //
// ./src/app/_models/staff.model.ts